import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../Theme';

const Wrapper = styled('div')`
  text-align: center;
  margin: 5rem 0;
  h2 {
    font-size: 2.25rem;
    margin-bottom: 1.125rem;
    line-height: 100%;
    font-weight: 700;
  }
  p {
    color: ${theme.colors.text};
    max-width: 34rem;
    line-height: 1.5;
    margin: 0 auto;
  }

  ${theme.below.md} {
    margin: 2.875rem 0;
    h2 {
      font-size: 1.5rem;
      margin-bottom: 0.625rem;
    }
    p {
      font-size: 0.875rem;
    }
  }
`;

const PostText = ({ category }) => {
  if (!category) return null;
  const { content, name } = category;
  if (!content || !name) return null;
  return (
    <Wrapper>
      <h2>{name}</h2>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </Wrapper>
  );
};

export default PostText;
